// Warehouse design tokens, shared by the warehouse components that are no
// longer carrying their own copy. The older pages keep a local copy for now.
export const theme = {
  colors: {
    charcoal: '#222725',
    sunburst: '#FFD44D',
    greenOnions: '#3BB273',
    imBlue: '#4E8098',
    crimson: '#E5625E',
    porcelain: '#F2EDE4',
    white: '#FFFFFF',
    grey100: '#F8F9F8',
    grey200: '#E7E5E4',
    grey300: '#D6D3D1',
    grey400: '#A8A29E',
    grey500: '#78716C',
    greenLight: '#E8F5EE',
    amberLight: '#FFF9E6',
    redLight: '#FCEEED',
    purple: '#8B5CF6',
    purpleLight: '#F5F3FF',
    blueLight: '#EDF3F6'
  },
  fonts: { sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif" },
  radius: { sm: '6px', md: '10px', lg: '16px' },
  shadows: { sm: '0 1px 2px rgba(0,0,0,0.05)', md: '0 4px 12px rgba(0,0,0,0.08)' }
}
